import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import {
  MDSText,
  MDSTextVariant,
  MDSButton,
  MDSButtonVariant,
  MDSModalDialog,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSButtonGroup,
} from "@/mds";

export const DeleteKeyModal = observer(() => {
  const { store } = useAppStore();

  const keyToDelete = store.apiKeys.apiKeyPendingDeletion;
  const isModalOpen = !!keyToDelete;
  const { id: keyId, title: keyTitle } = keyToDelete ?? {};

  const handleCloseModal = () => {
    store.apiKeys.closeDeleteApiKeyModal();
  };

  const handleDeleteApiKey = () => {
    if (!keyId) {
      store.apiKeys.closeDeleteApiKeyModal();
      return;
    }

    store.apiKeys.confirmDeleteApiKeyDeletion();
  };

  return (
    <MDSModalDialog isOpen={isModalOpen} handleClose={handleCloseModal}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        {keyTitle
          ? `Are you sure you want to delete “${keyTitle}”?`
          : "Are you sure you want to delete this API key?"}
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          Deletion is permanent and cannot be undone.
        </MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={handleCloseModal}>Cancel</MDSButton>
        <MDSButton variant={MDSButtonVariant.DangerFilled} onClick={handleDeleteApiKey}>
          Delete forever
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
